import priceChangesAlertElementShown from '@hh.ru/analytics-js-events/build/xhh/employer/price/cart/price_changes_alert_element_shown';
import { Alert, Button } from '@hh.ru/magritte-ui';
import { InfoCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatToReactComponent } from 'bloko/common/trl';

import ElementShownAnchor from 'src/components/ElementShownAnchor';
import HumanDate, { ShowYear } from 'src/components/HumanDate';
import translation from 'src/components/translation';
import { PriceChangeNotificationType } from 'src/models/price/priceCart';

interface PriceChangesAlertProps {
    visible: boolean;
    onClose: VoidFunction;
    newPriceDate: string;
    lastDateBeforeNewPrice: string;
    reason: PriceChangeNotificationType;
}

const TrlKeys = {
    title: 'price.cart.notifications.banner.alert.title',
    description: 'price.cart.notifications.banner.alert.description',
    close: 'close',
};

const PriceChangesAlert: TranslatedComponent<PriceChangesAlertProps> = ({
    onClose,
    visible,
    newPriceDate,
    lastDateBeforeNewPrice,
    reason,
    trls,
}) => {
    return (
        <Alert
            visible={visible}
            onClose={onClose}
            icon={<InfoCircleFilledSize24 />}
            title={formatToReactComponent(trls[TrlKeys.title], {
                '{0}': <HumanDate date={newPriceDate} showYear={ShowYear.Never} />,
            })}
            description={
                <ElementShownAnchor
                    fn={priceChangesAlertElementShown}
                    lastDateBeforeNewPrice={lastDateBeforeNewPrice}
                    reason={reason}
                >
                    {trls[TrlKeys.description]}
                </ElementShownAnchor>
            }
            layout="vertical"
            buttons={
                <Button mode="primary" style="accent" onClick={onClose}>
                    {trls[TrlKeys.close]}
                </Button>
            }
        />
    );
};

export default translation(PriceChangesAlert);
